<button class="btn-custom" type="button" *ngIf="!disabled" [style]="customStyle" [color]="color" (click)="onClick"
  [disableRipple]="true" mat-flat-button>
  {{lable}}
</button>
<button class="btn-custom" type="button" *ngIf="disabled" [style]="customStyle" [color]="color" [disabled]="disabled"
  mat-flat-button>
  {{lable}}
</button>
